import { Component, OnInit } from '@angular/core';
import { ApiKey, ApiKeyResource } from '@apaq/orgkit-js';
import { container } from 'tsyringe';

@Component({
  selector: 'app-developer-view',
  templateUrl: './developer-view.component.html',
  styleUrls: ['./developer-view.component.scss']
})
export class DeveloperViewComponent implements OnInit {

  keys: ApiKey[] = [];
  
  constructor(private apiKeyResource: ApiKeyResource) { }

  ngOnInit() {
    this.loadKeys();
  }

  async loadKeys() {
    this.keys = (await this.apiKeyResource.findAll()).content;
  }

  public async regenerateKeys() {
    if(await Stallion.confirm($localize`Are you sure you want to generate new Api Keys? Existing keys will be replaced.`, 'danger', undefined, $localize`Yes, generate new keys`)) {
      await this.apiKeyResource.regenerate();
      await this.loadKeys();
      Stallion.alert($localize`Api-keys were generated. You can use your new api-keys immediately.`, 'success');
    }
  }

}
